// Deployment status feature flag
export const ANNOUNCEMENT_FF = 'announcement';
